/* 
  This function looks for links in HTML content and adds a target="_blank" to them
*/

export default function targetLinksToNewTab(html) {
  const regex = new RegExp('<a([^>]*)>(.*?)</a>', 'g');
  return html.replace(regex, '<a$1 target="_blank">$2</a>');
}
